var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "areachart_wrapper chart_wrapper",
      attrs: { id: "ChartWrapper", "data-chart": "area" }
    },
    [
      _c("div", { staticClass: "area_legend_items" }, [
        _c(
          "div",
          { staticClass: "legend_group first" },
          _vm._l(_vm.legendItems, function(item, itemKey) {
            return _c("div", { staticClass: "legend_item" }, [
              _c("div", {
                staticClass: "item_chip",
                style: { backgroundColor: item.color }
              }),
              _c("div", { staticClass: "item_label" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(item.name) +
                    "\n                "
                )
              ])
            ])
          }),
          0
        )
      ]),
      _c(
        "div",
        {
          staticClass: "loader lds-ellipsis",
          class: _vm.loaderDisplayed ? "displayed" : ""
        },
        [_c("div"), _c("div"), _c("div"), _c("div")]
      ),
      _c("div", {
        staticClass: "highcharts_container areachart_container",
        attrs: { id: _vm.chartID }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eccec6a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eccec6a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/highchartsAreaChart.vue
// module id = 7rxt
// module chunks = 0 2